import { render } from "./headerWishlist.vue?vue&type=template&id=5d37a5d7&scoped=true"
import script from "./headerWishlist.vue?vue&type=script&lang=js"
export * from "./headerWishlist.vue?vue&type=script&lang=js"

import "./headerWishlist.vue?vue&type=style&index=0&id=5d37a5d7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d37a5d7"]])

export default __exports__